import React from 'react'
import '../assets/css/product-card.css'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function ProductCard({ product, isAuthenticated, onAddToCart }) {
  const [authenticate, setAuthenticate] = useState(localStorage.getItem('isAuthenticated'));
  const [productCount, setProductCount] = useState(1);
  const navigate = useNavigate();

  function addCart() {
    if (authenticate) {
      if (product.stock_status === 'instock') {
        onAddToCart(product, productCount);
      } else {
        toast.error("Product is out of stock!")
      }
    } else {
      navigate('/login');
      toast.error("Please login first!");
    }
  }

  return (
    <>
      <article key={product.id} className="product-card">
        <div className="card-image-placeholder">
          {product.images && product.images.length > 0 ? (
            <img
            style={{cursor:'pointer'}}
              src={product.images[0].src}
              alt={product.name}
              onClick={()=>navigate(`/product/${product.id}`)}
              className="product-img"
            />
          ) : (
            "No Image"
          )}
        </div>
        <h3 className="card-title" style={{ fontSize: '18px', padding: '5px 0 0', cursor:'pointer'}} onClick={()=>navigate(`/product/${product.id}`)}>{product.name}</h3>
        <p className="card-desc">
          {product.description?.replace(/<[^>]+>/g, "").slice(0, 80)}...
        </p>

      <div className="card-footer">
  <div className="card-price">
    ₹{product.price}
  </div>

  {product.stock_status === 'instock' ? (
    <button
      className="btn-add-cart"
      onClick={addCart}
      style={{ margin: '0 0 0 10px' }}
    >
      Add to cart
    </button>
  ) : (
    <button
      className="btn-add-cart out-of-stock"
      disabled
      style={{
        margin: '0 0 0 10px',
        backgroundColor: '#e5e7eb',
        color: '#6b7280',
        cursor: 'not-allowed'
      }}
    >
      Out of stock
    </button>
  )}
</div>

      </article>
    </>
  )
}

export default ProductCard